export const LOGICAL_WIDTH = 360;
export const LOGICAL_HEIGHT = 640;

export class Renderer {
  readonly canvas: HTMLCanvasElement;
  readonly ctx: CanvasRenderingContext2D;
  private dpr = 1;
  private cssWidth = 0;
  private cssHeight = 0;
  private scale = 1;
  private offsetX = 0;
  private offsetY = 0;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) throw new Error('Canvas 2D context unavailable');
    this.ctx = ctx;
    this.resize();
    window.addEventListener('resize', () => this.resize());
    window.addEventListener('orientationchange', () => this.resize());
  }

  resize(): void {
    const dpr = window.devicePixelRatio || 1;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    // Fit LOGICAL into viewport preserving aspect.
    const aspect = LOGICAL_WIDTH / LOGICAL_HEIGHT;
    let cssW = vw;
    let cssH = vw / aspect;
    if (cssH > vh) {
      cssH = vh;
      cssW = vh * aspect;
    }
    this.dpr = dpr;
    this.cssWidth = cssW;
    this.cssHeight = cssH;
    this.canvas.style.width = `${cssW}px`;
    this.canvas.style.height = `${cssH}px`;
    this.canvas.width = Math.round(cssW * dpr);
    this.canvas.height = Math.round(cssH * dpr);
    this.scale = (cssW * dpr) / LOGICAL_WIDTH;
    this.offsetX = 0;
    this.offsetY = 0;
    this.ctx.imageSmoothingEnabled = false;
  }

  /** Map CSS-relative pointer coords (within the canvas element) to logical coords. */
  pageToLogical(clientX: number, clientY: number): { x: number; y: number } {
    const rect = this.canvas.getBoundingClientRect();
    const lx = ((clientX - rect.left) / rect.width) * LOGICAL_WIDTH;
    const ly = ((clientY - rect.top) / rect.height) * LOGICAL_HEIGHT;
    return { x: lx, y: ly };
  }

  beginFrame(): void {
    const { ctx } = this;
    ctx.setTransform(this.scale, 0, 0, this.scale, this.offsetX, this.offsetY);
    ctx.fillStyle = '#0b0a0a';
    ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  }

  endFrame(): void {
    // No-op currently; reserved for post-processing.
  }

  get width(): number {
    return LOGICAL_WIDTH;
  }
  get height(): number {
    return LOGICAL_HEIGHT;
  }
  get pixelRatio(): number {
    return this.dpr;
  }
  get displayWidth(): number {
    return this.cssWidth;
  }
  get displayHeight(): number {
    return this.cssHeight;
  }
}
